import { __assign } from "tslib";
import React from 'react';
import classnames from 'classnames';
import Overlay from '../Overlay';
import ErrorBoundary from '../../../../ErrorBoundary';
import DeviationDumbView from '../../../Dumbo';
import Timestamp from '../../../../Timestamp';
import DeviationLink from '../../../../Duperbrowse/DeviationLink';
import { useOverlayContext } from '../../../hooks/useOverlayContext';
import overlayHelperStyles from '../OverlayHelpers.scss';
import s from './StatusThumb.scss';
var StatusThumb = function (_a) {
    var _b;
    var className = _a.className, deviation = _a.deviation, height = _a.height, responsive = _a.responsive, style = _a.style, width = _a.width, extraActions = _a.extraActions;
    var showOverlay = useOverlayContext(deviation).showOverlay;
    return (React.createElement("div", { className: classnames(s['root'], overlayHelperStyles['hoverable'], className), style: __assign({ width: width, height: height }, style) },
        React.createElement(ErrorBoundary, { debugComponent: "StatusThumb" },
            React.createElement(DeviationDumbView, { deviation: deviation, width: width, height: height, responsive: responsive }),
            React.createElement(Timestamp, { timestamp: deviation.publishedTime || ((_b = deviation.status) === null || _b === void 0 ? void 0 : _b.ts), className: s['status-date'] }),
            React.createElement(DeviationLink, { deviation: deviation, className: s['link-overlay'], title: deviation.title },
                React.createElement("span", null)),
            showOverlay && (React.createElement(Overlay, { deviation: deviation, width: width, height: height, className: s['overlay'], extraActions: extraActions })))));
};
StatusThumb.displayName = 'StatusThumb';
export default StatusThumb;
//# sourceMappingURL=StatusThumb.js.map